module.exports = __webpack_public_path__ + "static/media/blog-11.9299feb0.svg";